export enum RESPONSE_STATUS {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}

export enum CONTEXT {
  INSURANCE = "insurance",
  STANDALONE = "standalone",
  STANDALONE_V2 = "standalone_v2",
}

export enum PLATFORM {
  WEB = "web",
}

export enum LOB {
  STANDALONE = "standalone",
}

export enum ERROR_CODES {
  DISPLAY_ERROR = "DISPLAY_ERROR",
}

export enum UTM_PARAMS {
  UTM_SOURCE = "utm_source",
  UTM_MEDIUM = "utm_medium",
  UTM_CAMPAIGN = "utm_campaign",
  UTM_INS_CAMPAIGN = "utm_ins_campaign",
}

export enum STORAGE_KEYS {
  TRAVELLER_DETAILS = "traveller-details",
}

export const FORM_FIELDS_MAP = Object.freeze({
  name: "name",
  dob: "date of birth",
  gender: "gender",
  mobile: "mobile number",
  email: "email id",
  passport: "passport number",
});

export type FormFieldType =
  | "name"
  | "dob"
  | "gender"
  | "mobile"
  | "email"
  | "passport";

export const GENDER_VALUES = [
  {
    id: "1",
    label: "Male",
    isSelected: false,
  },
  {
    id: "2",
    label: "Female",
    isSelected: false,
  },
  {
    id: "3",
    label: "Others",
    isSelected: false,
  },
];

export const TXN_SUCCESS_REDIRECT_TIME = 5000;
export const TXN_FAILURE_REDIRECT_TIME = 5000;

export enum PASSPORT_DETAILS_PAGE_ID {
  PAYMENT_SUCCESS = "PAYMENT_SUCCESS",
  ORDER_CONFIRMED = "ORDER_CONFIRMED",
}

export const TRAVELLER_NUMBER_CONSTANTS = {
  MAX_TRAVELLERS: 20,
  MIN_TRAVELLERS: 1,
};

export const constants = {
  formErrorToast: "Please enter the required details to continue",
  addErrorToast: "Please add all traveller details to continue",
};
